export default __webpack_public_path__ + "static/media/desk_fury.af02969d.webp";